import TechnologySimpleForm from './TechnologySimpleForm'

export default TechnologySimpleForm
